export default "__VITE_ASSET__BH9gBIUs__"